export class UpdateProfessionnelTirage
{
    professionnelTirageId:number;
    montant:number;
    dateTirage:String;
    echeance:number;
}